import {createMuiTheme} from "@material-ui/core";

export const theme = createMuiTheme({
  palette: {
    primary: { main: "#219103", contrastText: "#fff" },
  },
});
